module.exports = __webpack_public_path__ + "static/scale-model-of-fleischmann-planetarium-in-reno-nevada-936b43e3384c801385633c64602e8017.png";